import type {
  ScheduleFormValues,
  WeekDaySettings,
} from '@app/components/Schedule/types';

export const schedule: Array<
  | {
      label: keyof ScheduleFormValues['schedule'];
      title: string;
    } & WeekDaySettings
> = [
  {
    label: 'monday',
    title: 'Понедельник',
    active: true,
    startTime: '09:00',
    endTime: '20:00',
  },
  {
    label: 'tuesday',
    title: 'Вторник',
    active: true,
    startTime: '09:00',
    endTime: '20:00',
  },
  {
    label: 'wednesday',
    title: 'Среда',
    active: true,
    startTime: '09:00',
    endTime: '20:00',
  },
  {
    label: 'thursday',
    title: 'Четверг',
    active: true,
    startTime: '09:00',
    endTime: '20:00',
  },
  {
    label: 'friday',
    title: 'Пятница',
    active: true,
    startTime: '09:00',
    endTime: '20:00',
  },
  {
    label: 'saturday',
    title: 'Суббота',
    active: false,
    startTime: '09:00',
    endTime: '20:00',
  },
  {
    label: 'sunday',
    title: 'Воскресенье',
    active: false,
    startTime: '09:00',
    endTime: '20:00',
  },
];
